import { MapPin, ArrowUpRight } from "lucide-react";
import { Reveal } from "./Reveal";

const GROUPS = [
  {
    title: "Connectivity",
    rows: [
      ["Eastern Express Highway", "1 min*"],
      ["Cadbury Junction Metro Station", "3 mins*"],
      ["Thane Bus Depot", "5 mins*"],
      ["Ghodbunder Road", "10 mins*"],
      ["Thane Railway Station", "15 mins*"],
      ["International Airport", "50 mins*"],
    ],
  },
  {
    title: "Retail & Lifestyle",
    rows: [
      ["Korum Mall", "3 mins*"],
      ["Lake Shore Mall", "4 mins*"],
      ["High Street Mall", "8 mins*"],
      ["R Mall Thane", "12 mins*"],
    ],
  },
  {
    title: "Social Infrastructure",
    rows: [
      ["Smt. Sulochanadevi Singhania School", "2 mins*"],
      ["Jupiter Hospital", "4 mins*"],
      ["Bethany Hospital", "6 mins*"],
      ["Hiranandani Hospital", "8 mins*"],
    ],
  },
];

export default function LocationSection() {
  return (
    <section id="location" data-testid="location-section" className="py-24 md:py-32 border-t border-border">
      <div className="max-w-screen-2xl mx-auto px-6">
        <Reveal className="max-w-3xl">
          <p className="text-[11px] uppercase tracking-[0.35em] text-primary mb-5">Location Advantages</p>
          <h2 className="font-display font-light text-4xl md:text-5xl lg:text-6xl leading-tight mb-6">
            Opp. Korum Mall, <span className="italic text-primary">near Cadbury Junction</span>
          </h2>
          <p className="text-muted-foreground text-sm md:text-base leading-relaxed mb-6">
            Road, rail, metro, tunnel and waterway links converge at Cadbury Junction — one of Maharashtra's four
            bullet-train hubs.
          </p>
          <a
            href="https://maps.app.goo.gl/W5brkzFyX2m8xEjz6"
            target="_blank"
            rel="noreferrer"
            data-testid="location-map-link"
            className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.25em] text-primary hover:text-foreground transition-colors mb-14"
          >
            View on Google Maps <ArrowUpRight size={14} />
          </a>
        </Reveal>
        <div className="grid md:grid-cols-3 gap-12">
          {GROUPS.map((g, gi) => (
            <Reveal key={g.title} delay={gi * 0.1}>
              <p className="text-[10px] uppercase tracking-[0.35em] text-muted-foreground mb-4 flex items-center gap-3">
                <MapPin size={13} className="text-primary" /> {g.title}
              </p>
              {g.rows.map(([place, time]) => (
                <div
                  key={place}
                  data-testid={`location-${place.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                  className="flex items-baseline justify-between gap-6 border-b border-border/60 py-3.5 hover:translate-x-1.5 transition-transform duration-300"
                >
                  <span className="text-sm text-foreground/90">{place}</span>
                  <span className="font-display text-lg text-primary whitespace-nowrap">{time}</span>
                </div>
              ))}
            </Reveal>
          ))}
        </div>
        <p className="text-[11px] text-muted-foreground/70 mt-8">*Travel times are indicative and subject to traffic conditions.</p>
      </div>
    </section>
  );
}
